/**
 * Utility for replacing placeholders in consent templates with actual survey data
 */

export interface SurveyData {
  orgName?: string;
  districtName?: string;
  assessmentName?: string;
  timeframe?: string;
  semester?: string;
  year?: string;
}

/**
 * Replace placeholders in consent template content with actual survey data
 */
export const replaceConsentTemplatePlaceholders = (
  content: string,
  surveyData: SurveyData
): string => {
  let replacedContent = content;
  
  console.log('Placeholder replacement - Input content:', content);
  console.log('Placeholder replacement - Survey data:', surveyData);

  // Replace school name
  if (surveyData.orgName) {
    const before = replacedContent;
    replacedContent = replacedContent.replace(/\[SCHOOL\]/g, surveyData.orgName);
    if (before !== replacedContent) {
      console.log(`Replaced [SCHOOL] with "${surveyData.orgName}"`);
    }
  }

  // Replace district name
  if (surveyData.districtName) {
    const before = replacedContent;
    replacedContent = replacedContent.replace(/\[DISTRICT\]/g, surveyData.districtName);
    if (before !== replacedContent) {
      console.log(`Replaced [DISTRICT] with "${surveyData.districtName}"`);
    }
  }

  // Replace timeframe
  if (surveyData.timeframe) {
    const before = replacedContent;
    replacedContent = replacedContent.replace(/\[TIMEFRAME\]/g, surveyData.timeframe);
    if (before !== replacedContent) {
      console.log(`Replaced [TIMEFRAME] with "${surveyData.timeframe}"`);
    }
  }

  // Replace assessment name
  if (surveyData.assessmentName) {
    const before = replacedContent;
    replacedContent = replacedContent.replace(/\[ASSESSMENT\]/g, surveyData.assessmentName);
    if (before !== replacedContent) {
      console.log(`Replaced [ASSESSMENT] with "${surveyData.assessmentName}"`);
    }
  }

  console.log('Placeholder replacement - Final content:', replacedContent);
  return replacedContent;
};

/**
 * Get available placeholders based on survey data
 */
export const getAvailablePlaceholders = (surveyData: SurveyData): string[] => {
  const placeholders: string[] = [];
  
  if (surveyData.orgName) {
    placeholders.push('[SCHOOL]');
  }
  
  if (surveyData.districtName) {
    placeholders.push('[DISTRICT]');
  }
  
  if (surveyData.timeframe || (surveyData.semester && surveyData.year)) {
    placeholders.push('[TIMEFRAME]');
  }
  
  if (surveyData.assessmentName) {
    placeholders.push('[ASSESSMENT]');
  }
  
  return placeholders;
};
